import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import logo from '../../../../img/cc-logo-2022-white.svg';
import { Link } from 'react-router-dom';

export default class ChangePassword extends React.Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
	};

	state = {
		isAccountReset: false,
		oldPassword: '',
		password1: '',
		password2: '',
		passwordReset: false,
		passwordWarning: '',
		isPasswordWarning: false,
		isPasswordsWarning: false,
	};

	handleOldPasswordChange = ({ target }) => {
		this.setState({ oldPassword: target.value });
	};

	handlePassword1Change = ({ target }) => {
		this.setState({
			password1: target.value,
			passwordWarning: '',
			isPasswordWarning: false,
			isPasswordsWarning: false,
		});
	};

	handlePassword2Change = ({ target }) => {
		this.setState({
			password2: target.value,
			passwordWarning: '',
			isPasswordWarning: false,
			isPasswordsWarning: false,
		});
	};

	changePassword = (event) => {
		const { oldPassword, password1, password2 } = this.state;
		event.preventDefault();
		this.setState({ isError: false, isUnknownError: false });
		// min length
		if (password1.length < 8) {
			this.setState({
				passwordWarning:
					'Your password must be at least 8 characters in length',
				isPasswordWarning: true,
			});
			return;
			// passwords must match
		} else if (password1 !== password2) {
			this.setState({
				passwordWarning: 'Your passwords do not match',
				isPasswordsWarning: true,
			});
			return;
			// old and new must not match
		} else if (oldPassword === password1) {
			this.setState({
				passwordWarning: 'New password must not be the same as old password',
				isPasswordsWarning: true,
			});
			return;
		}
		this.props.user.changePassword(oldPassword, password1).then(
			(result) => {
				if (result && result.passwordChange === true) {
					this.setState({ passwordReset: true });
				} else {
					// error
					this.setState({
						isError: true,
					});
				}
			},
			() => {
				// error
				this.setState({
					isUnknownError: true,
				});
			}
		);
	};

	render() {
		const {
			oldPassword,
			password1,
			password2,
			passwordReset,
			isError,
			isUnknownError,
			passwordWarning,
			isPasswordWarning,
			isPasswordsWarning,
		} = this.state;

		return (
			<div className="main block-center mt-xl wd-xl">
				<div className="panel panel-dark panel-flat">
					<div className="panel-heading text-center">
						<Link to="/">
							<img src={logo} />
						</Link>
					</div>
					<div className="panel-body">
						<h4 className="text-center pv">Change Password</h4>
						{isError && (
							<p className="text-center text-danger">
								An error occurred while attempting to change your password,
								please try again later. If problem persists, please contact
								support.
							</p>
						)}
						{isUnknownError && (
							<p className="text-center text-danger">
								An error occurred while attempting to change your password.
								Please contact support.
							</p>
						)}
						{passwordReset ? (
							<div className="message">
								<p className="text-center">Your password has been changed.</p>
								<p className="text-center">
									<Link to="/">
										Return to the home page to login with your new password.
									</Link>
								</p>
							</div>
						) : (
							<form onSubmit={this.changePassword}>
								{(isPasswordWarning || isPasswordsWarning) && (
									<p className="text-center text-danger">{passwordWarning}</p>
								)}
								<div className="form-group has-feedback">
									<label htmlFor="inputPasswordOld">Current Password</label>
									<input
										type="password"
										className="form-control password"
										required="required"
										autoComplete="current-password"
										onChange={this.handleOldPasswordChange}
										value={oldPassword}
										id="inputPasswordOld"
									/>
									<span className="fa fa-lock form-control-feedback text-muted"></span>
								</div>
								<div
									className={cn('form-group', 'has-feedback', {
										'has-error': isPasswordWarning || isPasswordsWarning,
									})}
								>
									<label htmlFor="inputPassword1">Password</label>
									<input
										type="password"
										className="form-control password"
										required="required"
										autoComplete="new-password"
										onChange={this.handlePassword1Change}
										value={password1}
										id="inputPassword1"
									/>
									<span className="fa fa-lock form-control-feedback text-muted"></span>
								</div>
								<div
									className={cn('form-group', 'has-feedback', {
										'has-error': isPasswordsWarning,
									})}
								>
									<label htmlFor="inputPassword2">Confirm Password</label>
									<input
										type="password"
										className="form-control password"
										required="required"
										autoComplete="new-password"
										onChange={this.handlePassword2Change}
										value={password2}
										id="inputPassword2"
									/>
									<span className="fa fa-lock form-control-feedback text-muted"></span>
								</div>
								<button className="btn btn-danger btn-block" type="submit">
									Change Password
								</button>
							</form>
						)}
					</div>
				</div>
			</div>
		);
	}
}
